// @ts-ignore
import * as ReactPixel from 'react-facebook-pixel';
import Config from "../Config/Config";

// import Config from "../Config/Config";

// USING default as a workaround to enable ReactPixel
ReactPixel['default'].init(Config.facebookPixel());
const shouldTrackAnalytics = Config.shouldTrackAnalytics();

export default class FBPixelService {
    public static track(eventName: string) {
        if (!shouldTrackAnalytics) {
            return;
        }
        ReactPixel['default'].track(eventName, {});
    }

}



// WEBPACK FOOTER //
// ./src/services/Analytics/FBPixelService.ts